// rm-app-shell.js — top-level router host.
//
// Mirrors `<kfe-app-shell>` from KFE web. Declares routes and mounts the
// matched screen into a single host slot. Routes are simple path patterns
// matched by `src/router.js`.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";
import { start as startRouter } from "../router.js";

export class RMAppShell extends RMComponent {
  static styles = `
    :host { display: flex; flex-direction: column; height: 100%; }
    header { padding: 0.75rem 1rem; border-bottom: 1px solid var(--rm-border); display: flex; align-items: center; gap: 0.75rem; }
    header h1 { font-size: 1rem; margin: 0; font-weight: 600; }
    main { flex: 1; min-height: 0; overflow: auto; }
    footer { padding: 0.5rem 1rem; border-top: 1px solid var(--rm-border); font-size: 0.75rem; color: var(--rm-muted); }
    .back {
      appearance: none;
      background: var(--rm-surface);
      color: var(--rm-fg);
      border: 1px solid var(--rm-border);
      border-radius: 0.4rem;
      padding: 0.25rem 0.6rem;
      font: inherit;
      font-size: 0.85rem;
      cursor: pointer;
      line-height: 1;
    }
    .back:hover { background: var(--rm-surface-hover); }
    .back[hidden] { display: none; }
  `;

  /** @type {HTMLButtonElement | null} */ _backBtn = null;

  render() {
    return html`
      <header>
        <button class="back" id="back" type="button" hidden>← Back</button>
        <h1>Rhythmic Mandarin</h1>
      </header>
      <main id="route-host"></main>
      <footer>RM web · v0.1.0</footer>
    `;
  }

  onConnected() {
    const root = this.shadowRoot;
    if (!root) return;
    const host = /** @type {HTMLElement | null} */ (root.getElementById("route-host"));
    if (!host) return;
    this._backBtn = /** @type {HTMLButtonElement | null} */ (root.getElementById("back"));
    this._backBtn?.addEventListener("click", () => history.back());

    startRouter([
      { path: "/",                tag: "rm-home" },
      { path: "/intro",           tag: "rm-intro" },
      { path: "/list/:listId",    tag: "rm-list",   props: (p) => ({ listId: p.listId }) },
      { path: "/play/:itemId",    tag: "rm-player", props: (p) => ({ itemId: p.itemId }) },
      { path: "/how-to",          tag: "rm-how-to" },
    ], host);

    // Show the back button on every route except home. The router fires
    // `rm:routechange` after each navigation; we listen and toggle hidden.
    const updateBack = () => {
      if (!this._backBtn) return;
      this._backBtn.hidden = location.pathname === "/" || location.pathname === "";
    };
    updateBack();
    window.addEventListener("popstate", updateBack);
    window.addEventListener("rm:routechange", updateBack);
    this.addCleanup(() => {
      window.removeEventListener("popstate", updateBack);
      window.removeEventListener("rm:routechange", updateBack);
    });
  }
}
